import * as React from 'react';
import { ReactComponent as HelpIconSVG } from '../../assets/icons/mevo/ic_help.svg';
import IconPattern, { IconProps } from './_IconPattern';

const HelpIcon: React.FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={HelpIconSVG} variantPlaces={3} {...props} />;
};

export default HelpIcon;
